import type { PossibleEnvironment } from 'types/environment'
import type { Storefront } from 'types/models/storefront'
import { isValidEnvironment } from 'types/generic/geographic'
import { generatedStorefronts } from '~/data/storefronts'

/**
 * Returns all storefronts for a given environment
 */
export function getStorefronts(environment: PossibleEnvironment): Storefront[] {
  if (!isValidEnvironment(environment))
    throw new EvalError(`Invalid environment passed: ${environment}`)

  return generatedStorefronts.environments[environment]
}
